import * as ambassadorWixPaymentsTaxDocumentsV1TaxDocument from './payments-tax-documents-v1-tax-document-tax-documents.http.js';
import * as ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes from './payments-tax-documents-v1-tax-document-tax-documents.types.js';
import * as ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes from './payments-tax-documents-v1-tax-document-tax-documents.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getTaxDocument(): __PublicMethodMetaInfo<
  'GET',
  { taxDocumentId: string },
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes.GetTaxDocumentRequest,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes.GetTaxDocumentRequest,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes.GetTaxDocumentResponse,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes.GetTaxDocumentResponse
> {
  const payload = { taxDocumentId: ':taxDocumentId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsTaxDocumentsV1TaxDocument.getTaxDocument(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-documents/{taxDocumentId}',
    pathParams: { taxDocumentId: 'taxDocumentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listTaxDocuments(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes.ListTaxDocumentsRequest,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes.ListTaxDocumentsRequest,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes.ListTaxDocumentsResponse,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes.ListTaxDocumentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsTaxDocumentsV1TaxDocument.listTaxDocuments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-documents',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateFileDownloadInfo(): __PublicMethodMetaInfo<
  'GET',
  { taxDocumentId: string },
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes.GenerateFileDownloadInfoRequest,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes.GenerateFileDownloadInfoRequest,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentUniversalTypes.GenerateFileDownloadInfoResponse,
  ambassadorWixPaymentsTaxDocumentsV1TaxDocumentTypes.GenerateFileDownloadInfoResponse
> {
  const payload = { taxDocumentId: ':taxDocumentId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsTaxDocumentsV1TaxDocument.generateFileDownloadInfo(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-documents/{taxDocumentId}/generate-file-download-info',
    pathParams: { taxDocumentId: 'taxDocumentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TaxDocument as TaxDocumentOriginal,
  TaxDocumentType as TaxDocumentTypeOriginal,
  TaxDocumentTypeWithLiterals as TaxDocumentTypeWithLiteralsOriginal,
  TaxPeriod as TaxPeriodOriginal,
  TaxPeriodOptionsOneOf as TaxPeriodOptionsOneOfOriginal,
  YearPeriod as YearPeriodOriginal,
  SourceType as SourceTypeOriginal,
  SourceTypeWithLiterals as SourceTypeWithLiteralsOriginal,
  GetTaxDocumentFileHistoryRequest as GetTaxDocumentFileHistoryRequestOriginal,
  GetTaxDocumentFileHistoryResponse as GetTaxDocumentFileHistoryResponseOriginal,
  TaxDocumentFileHistory as TaxDocumentFileHistoryOriginal,
  TaxDocumentFileHistoryRecord as TaxDocumentFileHistoryRecordOriginal,
  GenerateHistoryFileDownloadInfoRequest as GenerateHistoryFileDownloadInfoRequestOriginal,
  GenerateHistoryFileDownloadInfoResponse as GenerateHistoryFileDownloadInfoResponseOriginal,
  Document as DocumentOriginal,
  UpdateTaxDocumentRequest as UpdateTaxDocumentRequestOriginal,
  UpdateTaxDocumentResponse as UpdateTaxDocumentResponseOriginal,
  RefreshTaxDocumentFileRequest as RefreshTaxDocumentFileRequestOriginal,
  RefreshTaxDocumentFileResponse as RefreshTaxDocumentFileResponseOriginal,
  GenerateFileUploadTargetRequest as GenerateFileUploadTargetRequestOriginal,
  GenerateFileUploadTargetResponse as GenerateFileUploadTargetResponseOriginal,
  FileUploadTarget as FileUploadTargetOriginal,
  ConfirmFileUploadedRequest as ConfirmFileUploadedRequestOriginal,
  ConfirmFileUploadedResponse as ConfirmFileUploadedResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetTaxDocumentRequest as GetTaxDocumentRequestOriginal,
  GetTaxDocumentResponse as GetTaxDocumentResponseOriginal,
  ListTaxDocumentsRequest as ListTaxDocumentsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListTaxDocumentsResponse as ListTaxDocumentsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  GenerateFileDownloadInfoRequest as GenerateFileDownloadInfoRequestOriginal,
  GenerateFileDownloadInfoResponse as GenerateFileDownloadInfoResponseOriginal,
} from './payments-tax-documents-v1-tax-document-tax-documents.types.js';
